// extracted by css-extract-rspack-plugin
var _1 = "b0lXm";
export { _1 as "container" }
